<template>
  <div>
    <!-- <div v-if="isAndroid" style="position: fixed;top:0;left:0;width:100%;height:100%">
      <div style="width:40%;position:relative;left: 50%;top: 20%;-webkit-transform: translate(-50%, -50%);-ms-transform: translate(-50%, -50%);transform: translate(-50%, -50%);">
        <wx-open-launch-weapp id="launch-btn" username="gh_76afa946b10f" :path="data.path" style="display:block;width:100%">
          <script type="text/wxtag-template">
            <style>.btn { width:100%;padding: 12px;color: white;background: #62b900;border:none;border-radius:4px;text-align:center;font-size:16px;
              }</style>
            <button class="btn">打开小程序</button>
          </script>
        </wx-open-launch-weapp>
      </div>
    </div> -->

    <div style="padding-top:100px">
      <h1 class="h1">打开你好陈真小程序</h1>
      <div @click="toWX" class="btn">你好，陈真</div>
    </div>
  </div>
</template>

<script>
import { Toast } from "vant";
export default {
  name: "index",
  data() {
    return {
      isAndroid: false,
      isPC: false,
      data: {},
    };
  },
  computed: {},
  created() {
    this.getIsAndroid();
  },
  methods: {
    getIsAndroid() {
      var u = navigator.userAgent;
      if((u.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i))) {
				// 移动端
        let data = JSON.parse(decodeURIComponent(this.$route.query.data));
        console.log(data)
        this.data = data;
        location.href = data.url_scheme;
				
			}else {
        // 非移动端
        this.isPC = true
			}
    },

    toWX() {
      if(this.isPC) {
        Toast("请在手机上查看。");
      } else {
        location.href = this.data.url_scheme;
      }
    }


  },
};
</script>

<style scoped>
.h1{
  text-align:center;
  margin-bottom:60px;
  font-size:46px
}
.btn{
  width: 220px;
  padding: 24px;
  color: white;
  background: #62b900;
  border:none;
  border-radius:6px;
  text-align:center;
  font-size:36px;
  display: block;
  margin: 0 auto;
}
</style>
